import { keepPreviousData, useQuery } from '@tanstack/react-query';

import type { ExtranetUsersListInput, ExtranetUsersListResponse } from '../../../types/extranet-api.types';
import { getExtranetApi } from '../extranetApi';
import { extranetQueryKeys } from '../queryKeys';

export const useUsersList = (input: ExtranetUsersListInput) =>
  useQuery({
    queryKey: extranetQueryKeys.users.list(input),
    queryFn: () => getExtranetApi().get<ExtranetUsersListInput, ExtranetUsersListResponse>('/v1/extranet/users', input),
    placeholderData: keepPreviousData,
  });
